const pumApplicableRegion = {
  co: true,
  cl: false,
  pe: false,
  mx: false,
};

const cmrApplicableRegion = {
  cl: true,
  co: true,
  pe: true,
  mx: false,
};

export { pumApplicableRegion, cmrApplicableRegion };
